import { ReactNode } from 'react';
import { slugify } from '@commutifi-fe/utils';

/**
 * If the title is a string, slugify it, otherwise return the title since a React element cannot be slugged
 * and it would not be possible to use URL hashes to refer to it easily
 * @param title - The title to slugify
 * @returns The slugged title if the title is a string, otherwise undefined
 */
export const getStringTitleSlug = (title: ReactNode) => typeof title === 'string' ? slugify(title) : undefined;